import type { EIncidentType } from './vulnerabilities.ts';

export const commonDateFormat = 'DD MMM YYYY';

export const commonDateTimeFormat = 'DD MMM YYYY HH:mm';

export const commonTimeFormat = 'hh:mm A';

export const MAX_COMPANY_NAME_LENGTH = 15;

export const RADIAN = Math.PI / 180;

export const unknownText = 'Unknown';

export const httpsUrlRegex = /^https:\/\/[^\s/]+(?:\/[^\s]*)?[^/]$/;

export type CompanyConfig = {
  default_owner?: string;
  default_incident_assignees?: string[];
  company_profile?: Record<string, unknown>;
  risk_review_process?: string;
  risk_id_prefix?: string;
  use_category_as_risk_id_prefix?: boolean;
  compliant_frameworks?: string[];
  incidentTypeToAssignees?: Record<EIncidentType, string>;
  security_meetings?: {
    cron: string;
    notes: Record<string, unknown>[];
    konfirmity_representative: string;
  };
};

export type CompanyRiskConfig = {
  risk_category_prefix_mapping?: Record<string, string>;
};
